module.exports = __webpack_public_path__ + "img/green.63f33a4f.svg";